module.exports = __webpack_public_path__ + "media/images/icons/brandenburg_gate-89799cb410e67296f649713e47858da1.svg";